import React from "react";
import {
    convertTo12HourFormat,
    formatDateIntoString,
} from "../../../utils/dateAndTime";
import SocialMediaHandles from "../../SocialMediaHandles/SocialMediaHandles";
import document_icon from "../../../assets/images/upload_document.svg"
import Question from "../../ui/QuestionComponent";
import Button from "../../ui/Button";

const EventDetails = ({
    data,
    handleCancelEvent,
    handleEditEvent
}) => {
    return (
        <>
            <div className="w-full p-6">
                <div className="flex justify-between items-center mb-7 pl-1 pr-1 sm:pr-8 sm:pl-8">
                    <p className="text-xl font-medium text-grey-900">
                        Event Details
                    </p>
                </div>
                <div className="flex flex-col items-center justify-center w-full rounded-2xl">
                    <div className="flex items-center justify-between w-full pl-1 pr-1 sm:pr-8 sm:pl-8 ">
                        {/* Event Details */}

                        <div className="mx-auto w-full">
                            <div className="flex flex-col gap-8 lg:flex-row md:gap-10 lg:gap-28">
                                {/* Left Section */}

                                <div className="flex-1 space-y-8 xs:w-14">
                                    {/* Event Date and Time */}
                                    <InfoRow
                                        icon="calendar-outline"
                                        title={data?.startDate && formatDateIntoString(data?.startDate)}
                                        content={
                                            data?.startTime &&
                                            data?.endTime && (
                                                <p className="text-sm font-normal text-grey-700">
                                                    {convertTo12HourFormat(data?.startTime)} - {convertTo12HourFormat(data?.endTime)}
                                                </p>
                                            )
                                        }
                                    />
                                    {/* Event Location and Address */}
                                    <InfoRow
                                        icon="location-outline"
                                        title={data?.location}
                                        content={<p className="text-sm font-normal text-grey-700">{data?.location}</p>}
                                    />

                                    {/* Registration Deadline */}
                                    <InfoRow
                                        icon="calendar-outline"
                                        title="Registration Deadline"
                                        content={
                                            data?.deadlineDate && (
                                                <p className="text-sm font-normal text-grey-700">
                                                    {formatDateIntoString(data.deadlineDate)}
                                                </p>
                                            )
                                        }
                                    />
                                    {/* Marketplace Vendor Capacity */}
                                    <InfoRow
                                        icon="person-outline"
                                        title="Marketplace Vendor Capacity"
                                        content={
                                            <p className="text-sm font-normal text-grey-700">{data?.sellerCapacity}</p>
                                        }
                                    />

                                    {/* Load in and out Date and time */}
                                    <InfoRow
                                        icon="calendar-outline"
                                        title="Load in & Load Out"
                                        content={
                                            <>
                                                <div className="flex justify-between text-sm font-normal text-grey-700">
                                                    <p>Load in:</p>
                                                    <p>{convertTo12HourFormat(data?.startTime || "00:00")}</p>
                                                </div>
                                                <div className="flex justify-between text-sm font-normal text-grey-700">
                                                    <p>Load out:</p>
                                                    <p>{convertTo12HourFormat(data?.endTime || "00:00")}</p>
                                                </div>

                                            </>
                                        }
                                    />
                                    {/* Website */}
                                    <InfoRow
                                        icon={null}
                                        title="Website"
                                        content={
                                            <p className="text-sm font-normal text-grey-700">{data?.eoEventWebsiteURL}</p>
                                        }
                                    />

                                    {/* Social Media */}
                                    <InfoRow
                                        icon={null}
                                        title="Social Media"
                                        content={
                                            data?.socialMediaHandles && (
                                                <div className="text-sm font-normal text-grey-700">
                                                    <SocialMediaHandles handles={data?.socialMediaHandles} />
                                                </div>
                                            )
                                        }
                                    />
                                </div>
                                {/* Right Section */}
                                <div className="flex-auto space-y-8 lg:w-64 md:w-full">
                                    {/* Booth Pricing / Registration Fee */}
                                    {(() => {
                                        // Filter for valid fee levels (must have isSet=true and a fee value)
                                        const validFeeLevels = data?.feeLevels?.filter(
                                            level => level.isSet && level.fee !== "" && level.fee != null
                                        ) || [];

                                        if (validFeeLevels.length > 0) {
                                            // New events with feeLevels array
                                            return (
                                                <InfoRow
                                                    icon="card-outline"
                                                    title="Booth Pricing"
                                                    content={
                                                        <div className="space-y-2">
                                                            {validFeeLevels.map((level, index) => (
                                                                <p key={index} className="text-sm font-normal text-grey-700">
                                                                    <span className="font-medium">{level.name}</span>: ${level.fee}
                                                                    {level.description && (
                                                                        <span className="text-grey-500 ml-1">- {level.description}</span>
                                                                    )}
                                                                </p>
                                                            ))}
                                                        </div>
                                                    }
                                                />
                                            );
                                        }

                                        // Legacy events or no valid fee levels
                                        return (
                                            <InfoRow
                                                icon="card-outline"
                                                title="Registration Fee"
                                                content={
                                                    <p className="text-sm font-normal text-grey-700">
                                                        {data?.registrationFee != null ? `$${data.registrationFee}` : "Not set"}
                                                    </p>
                                                }
                                            />
                                        );
                                    })()}

                                    {/* Transaction Fee */}
                                    <InfoRow
                                        icon="card-outline"
                                        title="Transation Fee"
                                        content={
                                            <p className="text-sm font-normal text-grey-700">
                                                {`${data.transactionFeePercentage || 0}%`}
                                            </p>
                                        }
                                    />
                                    {/* About */}
                                    <div className="flex gap-2 font-medium">
                                        <div className="space-y-1">
                                            <span className="font-medium text-md text-grey-900">
                                                About
                                            </span>
                                            <p className="text-sm font-normal text-grey-700">
                                                {data.description}
                                            </p>
                                        </div>
                                    </div>

                                    {/*documents*/}
                                    {data?.eventDocuments?.length > 0 && (
                                        <div className="w-full grid grid-cols-2 gap-4">
                                            {data?.eventDocuments.map((document, index) => (
                                                <a href={document.file} target="_blank" rel="noreferrer" key={index} className="border border-grey-300 rounded-2xl p-8 flex flex-col items-center justify-center">
                                                    <img
                                                        src={document_icon}
                                                        alt=""
                                                        className="h-[40px] w-[40px]"
                                                    />
                                                    <p className="pt-2 text-sm font-medium text-success-700 whitespace-nowrap">
                                                        {document?.fileName?.length > 15
                                                            ? `${document?.fileName.slice(0, 15)}...`
                                                            : document?.fileName}
                                                    </p>
                                                </a>
                                            ))}
                                        </div>
                                    )}
                                    {/* Required documents */}
                                    <div className="flex gap-2 font-medium">
                                        <div className="space-y-1">
                                            <span className="font-medium text-md text-grey-900">
                                                Required Documentation
                                            </span>
                                            <p className="text-sm font-normal text-grey-700">
                                                <ul className="pl-5 list-solid-dot">
                                                    {data?.documents?.map((doc, index) => (
                                                        <li key={index}>{doc.documentName}</li>
                                                    ))}
                                                </ul>
                                            </p>
                                        </div>
                                    </div>
                                    {/* Permitted Marketplace Vendor Types */}
                                    <div className="flex gap-2 font-medium">
                                        {/* <ion-icon
                      name="calendar-outline"
                      className="text-xl font-medium"
                    ></ion-icon> */}
                                        <div className="space-y-1">
                                            <span className="font-medium text-md text-grey-900">
                                                Permitted Marketplace Vendor Types
                                            </span>
                                            <p className="text-sm font-normal text-grey-900">
                                                <div className="grid grid-cols-1 gap-2 text-xs md:grid-cols-2 lg:grid-cols-3 text-grey-900">
                                                    {data?.sellerTypes?.map((type) => (
                                                        <div
                                                            key={type}
                                                            className="flex items-center space-x-10"
                                                        >
                                                            <label className="text-xs text-grey-900">
                                                                {type}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p className="text-grey-900 text-xl font-medium mt-8">Additional Details</p>

                            {/*event map*/}
                            <p className="text-sm font-medium my-2">Event Map</p>
                            <a href={data?.eventMap?.file} target="_blank" rel="noreferrer" className="border border-grey-300 rounded-2xl p-8 flex flex-col items-center justify-center max-w-[166px] mt-4">
                                <img
                                    src={document_icon}
                                    alt=""
                                    className="h-[40px] w-[40px]"
                                />
                                <p className="pt-2 text-sm font-medium text-success-700 whitespace-nowrap">
                                    {data?.eventMap?.fileName?.length > 15
                                        ? `${data?.eventMap?.fileName.slice(0, 15)}...`
                                        : data?.eventMap?.fileName}
                                </p>
                            </a>

                            {/*questions*/}
                            <p className="text-sm font-medium my-2 mt-8">Questions for Marketplace Vendors</p>
                            {data?.typeOfQuestionList?.map((question, index) => (
                                <Question
                                    key={index}
                                    question={question}
                                    //onChange={handleQuestionChange}
                                    // errors={errors}
                                    index={index}
                                />
                            ))}
                        </div>
                    </div>

                </div>
                <div className="flex justify-end mt-6 gap-6 w-full">
                    <Button onClick={handleCancelEvent} variant="transparent">
                        Cancel Event
                    </Button>
                    <Button onClick={handleEditEvent} >
                        Edit Event
                    </Button>
                </div>
            </div>
        </>
    );
};

export default EventDetails;

export const InfoRow = ({ icon, title, content }) => (
    <div className="flex gap-2 font-medium">
        {icon && (
            <div className="text-2xl">
                <ion-icon name={icon} className="text-xl font-medium"></ion-icon>
            </div>
        )}
        <div className="space-y-1">
            {title && <span className="font-medium text-md text-grey-900">{title}</span>}
            {content}
        </div>
    </div>
);